document.addEventListener('click', function (e) {
    if (!e.target.closest('#btnAgregarAlmacenadoSoplado')) return;

    const inputId = document.getElementById('idReporteSopladoAgregarAlmacenado');
    const fuente  = document.getElementById('idReporteSoplado');
    if (inputId && fuente) inputId.value = fuente.value;
});

document.addEventListener('submit', function (e) {
    const form = e.target.closest('#formAgregarAlmacenadoSoplado');
    if (!form) return;
    e.preventDefault();

    const btnSubmit = form.querySelector('[type="submit"]');
    if (btnSubmit) btnSubmit.disabled = true;

    const data = new FormData(form);

    fetch('/api/soplado/agregar-entrega-almacenado', {
        method: 'POST',
        credentials: 'include',
        body: data
    })
    .then(function(r) { return r.json(); })
    .then(function(json) {
        const resultado = json.result ? json.result : {};
        const errores = resultado.errores ?? [];
        errores.forEach(e => {
            lanzarAlerta(e.mensaje, e.clase);
            const campo = form.querySelector('[name="' + e.campo + '"]');
            if (campo) campo.classList.add('inputRojo');
        });

        if (!resultado.hayErrores) {
            const inputIdReporte = document.getElementById('idReporteSopladoAgregarAlmacenado');
            const idReporte = inputIdReporte ? inputIdReporte.value : '';

            const modal = form.closest('.modal');
            if (modal) {
                form.reset();
                modal.classList.remove('modal--show');
            }
            if (idReporte && typeof window.actualizarTablaAlmacenado === 'function') {
                window.actualizarTablaAlmacenado(idReporte);
            }
            if (typeof window.actualizarModalReporteSoplado === 'function') {
                window.actualizarModalReporteSoplado(idReporte);
            }
            if (typeof window.actualizarBalanceSoplado === 'function') {
                window.actualizarBalanceSoplado(idReporte);
            }
            lanzarAlerta('Registro de paquete almacenado agregado exitosamente.', 'alerta-verde'); 
            
        }
    })
    .catch(function() { lanzarAlerta('Error al conectar con el servidor.', 'alerta-roja'); })
    .finally(function() { if (btnSubmit) btnSubmit.disabled = false; });
});
